module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "LeadScorz",
      "title": "LeadScorz"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "alert alert-danger",
    attrs: {
      "roler": "alert"
    }
  }, [_c('strong', [_vm._v("Wrong email/password")]), _vm._v(" Please, try again")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Email",
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Password",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" Remember me")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-primary btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/reset-password"
    }
  }, [_vm._v("Forgot your password?")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25631446"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 648
// module chunks = 0